import type { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export type ProfileFormErrors = Partial<
    Record<'name' | 'fieldActivityId' | 'locationId' | 'form', string>
>;

export const mapProfileFormErrors = (
    errors: IDataResponseError['errors'] = []
): ProfileFormErrors =>
    errors.reduce<ProfileFormErrors>((acc, error) => {
        switch (error.source.pointer) {
            case 'name':
                acc.name = error.title;
                break;
            case 'field_activity_id':
            case 'fieldActivity':
                acc.fieldActivityId = error.title;
                break;
            case 'city_id':
            case 'country_id':
            case 'city':
            case 'country':
                acc.locationId = error.title;
                break;
            default:
                acc.form = error.title;
        }

        return acc;
    }, {});
